import { requestZgy, requestYfdM } from './request'
import moment from 'moment'
import { stringify } from 'qs'

const getResumeChannels = () => requestZgy('/ep-garden/channel/channel_map/h5')

const resumeWithPosition = () =>
  requestZgy('/ep-garden/raw_resume/with_position', {
    method: 'GET',
  })

const resumeWithOutPosition = p =>
  requestZgy(
    `/ep-garden/raw_resume/without_position?pageSize=${p.pageSize}&pageNo=${
      p.pageNo
    }`,
    {
      method: 'GET',
    },
  )

const assignPosition = p =>
  requestZgy(
    `/ep-garden/raw_resume/assign_position?submitResumeIds=${
      p.submitResumeId
    }&positionIds=${p.positionIds}`,
    {
      method: 'POST',
    },
  )

const getResumes = url =>
  requestZgy(url, {
    method: 'GET',
  })

const getCity = () =>
  requestZgy('/ep-garden/position/city', {
    method: 'GET',
  })

const getHrCity = () =>
  requestZgy('/ep-garden/position/hr_city', {
    method: 'GET',
  })

const getHrPosition = () =>
  requestZgy('/ep-garden/position/hr_position', {
    method: 'GET',
  })

const hrPositionQuery = p =>
  requestZgy(p.url, {
    method: 'GET',
  })

const getDeptCity = p =>
  requestZgy(
    `/ep-garden/position/dept_city?department=${encodeURI(p.depart)}`,
    {
      method: 'GET',
    },
  )
/**
 * 检测二维码是否失效
 * @param {Object} query
 * @param {String} query.id
 * @param {String} query.secChannelId
 */
const checkQrCodeStatus = query => {
  const qs = stringify(query)
  return requestZgy(`/ep-garden/channel/check/twoBarCode?${qs}`, {
    method: 'GET',
  })
}
/**
 * 获取职位列表
 * @param {Object} query
 * @param {String} query.cityId
 * @param {String} query.recruitmentWebsiteId
 * @param {Number} query.flag
 * @param {Number} query.type
 * @param {String} query.teachType
 * @param {String} query.positionName
 */
const getDeptPositionNew = query => {
  const qs = stringify(query)
  return requestZgy(
    `/ep-garden-position/recruitment_website/position/list?${qs}`,
  )
}

const getMyDepartment = () =>
  requestZgy('/ep-garden/position/my_department', {
    method: 'GET',
  })

const getDegree = () =>
  requestZgy('/ep-garden/meta/degree', {
    method: 'GET',
  })

const getEnglishLevel = () =>
  requestZgy('/ep-garden/meta/english_level', {
    method: 'GET',
  })

const getGender = () =>
  requestZgy('/ep-garden/meta/gender', {
    method: 'GET',
  })

const parseResume = p =>
  requestZgy('/ep-garden-candidate/api/resume/parse', {
    method: 'post',
    body: p.body,
  })

const uploadSingleResume = p =>
  requestZgy('/ep-garden-candidate/api/resume/upload', {
    method: 'post',
    body: p.body,
  })

const uploadTutorResume = p =>
  requestZgy('/ep-garden-candidate/api/resume/tutor/upload', {
    method: 'post',
    body: p.body,
  })

const schoolUploadResume = p =>
  requestZgy('/ep-garden-candidate/api/school_recruitment/resume/upload', {
    method: 'post',
    body: p.body,
  })

const getFilters = () =>
  requestZgy('/ep-garden/resume/filters', {
    method: 'get',
  })

const passResumes = p =>
  requestZgy('/ep-garden/resume/pass?ids=' + p.ids, {
    method: 'post',
  })

const changePosition = p =>
  requestZgy(
    `/ep-garden/resume/${p.submitResumeId}/change_position?positionIds=${
      p.positionIds
    }`,
    {
      method: 'POST',
    },
  )

const eliminateResume = p =>
  requestZgy(
    `/ep-garden/submit_resume/eliminate?ids=${p.ids}&reason=${
      p.reason
    }&currentStatus=${p.currentStatus}`,
    {
      method: 'post',
    },
  )

const commentResume = p =>
  requestZgy(
    `/ep-garden/submit_resume/detail/${p.id}/comment?comment=${p.comment}`,
    {
      method: 'post',
    },
  )

const getComment = p =>
  requestZgy(`/ep-garden/submit_resume/detail/${p.id}/comment`, {
    method: 'get',
  })

const getCandidate = p =>
  requestZgy(`/ep-garden/submit_resume/detail/${p.id}/plain`, {
    method: 'get',
  })

const getCandidateHistory = p =>
  requestZgy(`/ep-garden/submit_resume/detail/history/${p.id}`, {
    method: 'get',
  })

const getCandidateDetail = p =>
  requestZgy(`/ep-garden/submit_resume/detail/${p.id}`, {
    method: 'get',
  })

const editCandidate = p =>
  requestZgy(`/ep-garden/submit_resume/detail/${p.id}`, {
    method: 'POST',
    body: p.body,
  })

const getPageTotal = function(p) {
  let pageTotal = p.count / p.pageSize
  let totalPage =
    parseInt(pageTotal) < pageTotal
      ? parseInt(pageTotal) + 1
      : parseInt(pageTotal)
  return totalPage
}

const metaCandidate = () =>
  requestZgy(`/ep-garden/meta/candidate`, {
    method: 'get',
  })

const resumeLogs = url =>
  requestZgy(url, {
    method: 'GET',
  })

const getRecordStatus = () =>
  requestZgy(`/ep-garden/resume/resume_record/status`, {
    method: 'GET',
  })

const getTalentStatus = () =>
  requestZgy(`/ep-garden/candidate_pool/status`, {
    method: 'GET',
  })

const offerFilters = () =>
  requestZgy('/ep-garden/offer/filters', {
    method: 'GET',
  })

const isMobile = function(num) {
  let mobileReg = /^[1][0-9]{10}$/
  if (!mobileReg.test(num)) {
    return false
  } else {
    return true
  }
}

const isEmail = function(email) {
  let emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/i
  if (!emailReg.test(email)) {
    return false
  } else {
    return true
  }
}

const compareTime = function(startDate, endDate) {
  return moment(startDate).valueOf() >= moment(endDate).valueOf()
}

const universityLevel = () =>
  requestZgy('/ep-garden/meta/university_level', {
    method: 'GET',
  })

// 查询活动黑名单
const checkBlackList = userId =>
  requestYfdM(
    `/ep-garden-tutor-recruitment-growth/api/user/${userId}/black-list`,
  )

export {
  getResumeChannels,
  getResumes,
  getDegree,
  getEnglishLevel,
  parseResume,
  uploadSingleResume,
  uploadTutorResume,
  schoolUploadResume,
  getGender,
  getCity,
  getFilters,
  passResumes,
  changePosition,
  eliminateResume,
  commentResume,
  getComment,
  getCandidate,
  getCandidateHistory,
  getPageTotal,
  metaCandidate,
  getMyDepartment,
  getHrCity,
  getHrPosition,
  hrPositionQuery,
  getDeptCity,
  checkQrCodeStatus,
  getDeptPositionNew,
  getCandidateDetail,
  editCandidate,
  resumeLogs,
  getRecordStatus,
  getTalentStatus,
  resumeWithPosition,
  resumeWithOutPosition,
  assignPosition,
  offerFilters,
  isMobile,
  isEmail,
  compareTime,
  universityLevel,
  checkBlackList,
}
